import { timeline } from 'wix-animations';

export function animateRepeater(repeaters) {
    const timelines = [];
    const rotateArrow = (arrow, rotateIndex) => {
        const timeLine = timelines[arrow.uniqueId] ?? timeline();
        timelines[arrow.uniqueId] = timeLine;
        timeLine.add(
            arrow, {
            "rotate": rotateIndex,
            "duration": 200
        },
        ).play();
    }
    repeaters.forEach(({ clickableBoxId, expandedTextId, arrowId }) => {
        $w(clickableBoxId).onClick((event) => {
            const $item = $w.at(event.context);
            const arrow = $item(arrowId);
            if ($item(expandedTextId).collapsed) {
                $item(expandedTextId).expand();
                rotateArrow(arrow, 180)
            } else {
                $item(expandedTextId).collapse()
                rotateArrow(arrow, 0)
            }
        });
    });
}